// @ts-check

/*  thanks to: http://james.padolsey.com/javascript/detect-ie-in-js-using-conditional-comments/ */

// obsolete?
const ie = (function() {
    let undef,
        v = 3,
        div = document.createElement ("div"),
        all = div.getElementsByTagName ("i")

    while (
        ((div.innerHTML = "<!--[if gt IE " + ++v + "]><i></i><![endif]-->"),
        all[0])
    )
        return v > 4 ? v : undef
}) ()

// this module seems obsolete?
export const Transform = (function() {
    const scale3d = (a, b, c) => {
        // return "scale3d(%s, %s, %s)".fmt(a, b, c);
        return `scale3d(${a}, ${b}, ${c})`
    }

    const translateX = a => {
        // return "translateX(%s)".fmt(a);
        return `translateX(${a})`
    }

    const translateY = a => {
        // return "translateY(%s)".fmt(a);
        return `translateY(${a})`
    }

    const translate3d = (a, b, c) => {
        let cmd
        if (ie === 9) {
            // ignore c:
            // cmd = "%s %s".fmt(translateX(a), translateY(b));
            a = translateX (a)
            b = translateY (b)
            cmd = `${a} ${b}`
        } else {
            // cmd = "translate3d(%s, %s, %s)".fmt(a, b, c);
            cmd = `translate3d(${a}, ${b}, ${c})`
        }
        return cmd
    }

    const getTransitions = a => {
        const attrs = [
            "-webkit-transition",
            "-moz-transition",
            "-o-transition",
            "-ms-transition",
            "transition"
        ]
        return a.getStyles (attrs)
    }

    const transition = (a, b) => {
        a.setStyles ({
            "-webkit-transition": b,
            "-moz-transition": b,
            "-o-transition": b,
            "-ms-transition": b,
            transition: b
        })
        // console.log("set transition:", a, b, a.getStyle("transition"));
    }

    const transform = (a, b) => {
        if (ie === 9) {
            a.style.msTransform = b
        } else {
            a.setStyles ({
                "-webkit-transform": b,
                "-moz-transform": b,
                "-o-transform": b,
                "-ms-transform": b,
                transform: b
            })
        }
    }

    const setDuration = (a, b) => {
        a.setStyles ({
            "-webkit-transition-duration": b + "s",
            "-moz-transition-duration": b + "s",
            "-o-transition-duration": b + "s",
            "-ms-transition-duration": b + "s",
            "transition-duration": b + "s"
        })
    }

    const clearDuration = a => {
        a.setStyles ({
            "-webkit-transition-duration": "",
            "-moz-transition-duration": "",
            "-o-transition-duration": "",
            "-ms-transition-duration": "",
            "transition-duration": ""
        })
    }

    const setTimingFunction = (a, b) => {
        a.setStyles ({
            "-webkit-transition-timing-function": b,
            "-moz-transition-timing-function": b,
            "-o-transition-timing-function": b,
            "-ms-transition-timing-function": b,
            "transition-timing-function": b
        })
    }

    const clearTimingFunction = a => {
        a.setStyles ({
            "-webkit-transition-timing-function": "",
            "-moz-transition-timing-function": "",
            "-o-transition-timing-function": "",
            "-ms-transition-timing-function": "",
            "transition-timing-function": ""
        })
    }

    return {
        scale3d: scale3d,
        translate3d: translate3d,

        transition: transition,
        transform: transform,
        translateX: translateX,
        translateY: translateY,

        setDuration: setDuration,
        clearDuration: clearDuration,
        setTimingFunction: setTimingFunction,
        clearTimingFunction: clearTimingFunction,
        getTransitions: getTransitions
    }
}) ()

//module.exports = Transform;
export default Transform
